module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C702"
  }, [_c('span', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("C")]), _vm._v("HAPTER ONE")]), _vm._v(" "), _c('p', {
    staticClass: "P75"
  }, [_c('span', {
    attrs: {
      "id": "id_19"
    }
  }, [_vm._v("H")]), _vm._v("ISTORY IN THE MAKING")]), _vm._v(" "), _c('p', {
    staticClass: "P58"
  }, [_c('img', {
    staticClass: "Image3",
    attrs: {
      "alt": "image",
      "src": "html/images/p0001-1.gif"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "C736"
  }, [_c('em', [_vm._v("The author with Dr. King at a press conference announcing the settlement agreement with the City of Birmingham ending segregation of downtown department stores, lunch counters, and public facilities")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "C736"
  }, [_c('em', [_vm._v("Photo: Ernst Haas/Getty Images")])]), _vm._v(" "), _c('p', {
    staticClass: "break1"
  }), _vm._v(" "), _c('p', {
    staticClass: "C738"
  }, [_c('em', [_c('span', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("They")]), _vm._v(" cried, and their cry came up unto God by reason of their bondage")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "C668a"
  }, [_vm._v("—Exodus 2:23")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f763127c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/06_CHAPTER.vue
// module id = 75
// module chunks = 0